import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    deleteUrl: String,
    revokeUrl: String
  }

  declare readonly deleteUrlValue: string
  declare readonly revokeUrlValue: string

  showEditModal() {
    const modal = document.getElementById('api_key_edit_modal') as HTMLDialogElement
    modal?.showModal()
  }

  showDeleteModal() {
    const modal = document.getElementById('api_key_delete_modal') as HTMLDialogElement

    if (modal) {
      modal.setAttribute('data-api-key-delete-url-value', this.deleteUrlValue)
      modal.setAttribute('data-api-key-delete-method-value', 'DELETE')
      modal.showModal()
    }
  }

  showRevokeModal() {
    const modal = document.getElementById('api_key_revoke_modal') as HTMLDialogElement

    if (modal) {
      modal.setAttribute('data-api-key-revoke-url-value', this.revokeUrlValue)
      modal.showModal()
    }
  }

  showReplayModal(event: Event) {
    event.preventDefault()
    const frame = document.getElementById('api_key_replay_frame') as HTMLElement & { src?: string }
    if (frame) {
      frame.setAttribute('src', (event.currentTarget as HTMLAnchorElement).href)
    }
  }
}
